module.exports = __webpack_public_path__ + "img/icon_l_hd.a15ad9fd.png";